import React from 'react'
import './style.scss'
import celular from '../../assets/images/celular.png'

export default function SectionControl() {
	return (
		<section className="container-section-control">
			<div className="section-control-left">
				<h1>Controle na palma da sua mão</h1>
				<div className="description calibri">
					Gerencie seu consumo e seus veículos cadastrados, além de realizar pagamentos, fazer recargas com facilidade e rapidez.
				</div>
			</div>
			<div className="container-image">
				<img src={celular} alt="" className="celular"/>
			</div>
		</section>
	)
}